import React from 'react';
import LoadingAnimation from '../common/LoadingAnimation';
import { useTranslation } from '../../hooks/useTranslation';

const RouteLoading = React.memo(() => {
  const { t } = useTranslation();
  return <LoadingAnimation fullPage message={t('common.justAMoment')} />;
});

RouteLoading.displayName = 'RouteLoading';

export default RouteLoading;
